import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  StaffDetailsTab: {
    padding: 20,
  },
  delete: {
    backgroundColor: "#F7F7F7",
    color: "#F04438 !important",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  formBox: {
    marginTop: "2rem",
  },
  password: {
    color: "#344054", // fallback for var(--Gray-700)
    fontFamily: "Inter",
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
    textDecorationSkipInk: "none",
    textDecorationThickness: "auto",
    textUnderlineOffset: "auto",
    textUnderlinePosition: "from-font",
  },


resetauthbox:{
  borderRadius: '16px',
  textAlign:'center',
background: '#F2F4F7',
padding:'4px 12px',
cursor:'pointer'
},


customokbutton: {
background:'#FFAF4A  !important' ,
color:'#171717 !important',
width:'440px !important',
height:'44px !important',
border:"1px solid #FFAF4A; !important",
borderRadius:"8px !important",
boxShadow:" 0 1px 2px 0 rgba(16, 24, 40, 0.05) !important",
padding:"8px 14px !important"
},

resetauth:{
      color: "#DC2626", 
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    textDecorationStyle: "solid",
  },

  
  tabContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    gap: "20px",
  },
  tab: {
    padding: "10px 0",
    cursor: "pointer",
    borderBottom: "2px solid transparent",
    transition: "all 0.2s ease",
    color: "#262626",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    width: "100%",
    textAlign: "center",
    textTransform: "capitalize",
  },
  activeTab: {
    fontWeight: 700,
    color: "#000",
    borderBottom: "2px solid #000",
  },
  disabledTab: {
    pointerEvents: "none",
    opacity: 0.5,
    cursor: "not-allowed",
    color: "#262626",
  },
  title: {
    margin: "0 20px",
    color: "#171717",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    marginTop: "15px",
  },
  rolesContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    gap: "20px",
    marginTop: "25px",
    width: "50%",
  },

    permissionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    flexDirection:'column',
    gap: "20px",
    marginTop: "25px",
    width: "50%",
  },
  swites: {
    "& .mantine-1knyxmk": {
      width: "100%",
    },
    "& input:checked:disabled + .mantine-n8464m": {
      backgroundColor: "#fab005 !important",
      borderColor: "#fab005 !important",
      opacity: 0.6,
      cursor: "not-allowed",
      pointerEvents: "auto !important",
    },
    "& input:disabled + .mantine-n8464m": {
      opacity: 0.6,
      cursor: "not-allowed",
      pointerEvents: "auto !important",
    },
  },

    Permissionswites: {
    "& .mantine-1knyxmk": {
      width: "100%",
    },
    "& input:checked:disabled + .mantine-ophoox": {
      backgroundColor: "#fab005 !important",
      borderColor: "#fab005 !important",
      opacity: 0.6,
      cursor: "not-allowed",
      pointerEvents: "auto !important",
    },
    "& input:disabled + .mantine-ophoox": {
      opacity: 0.6,
      cursor: "not-allowed",
      pointerEvents: "auto !important",
    },
  },
  staffInfoContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
    flexDirection: "column",
    // height: "30dvh",
  },
  // document css
  row: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginTop: 10,
    marginBottom: 10,
  },
  innerRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    background: "rgba(242, 242, 242, 1)",
    border: "1px solid #E5E5E5",
    borderRadius: "4px",
  },
  imgName: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
    justifyContent: "start",
  },
  yellowButton: {
    background: "rgba(255, 186, 69, 0.85)",
  },
  iconButton: {
    // background: "rgba(255, 186, 69, 0.85)", // yellow
    padding: "6px 15px",
    borderRadius: "5px",
    marginInline: 5,
    display: "flex",
    alignItems: "center",
  },

  column: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    marginBottom: "20px",
    borderRus: 4,
    background: "#F4F4F5",
    marginTop: "20px",
    cursor: "pointer",
  },
  uploadFileContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    marginBottom: "20px",
    borderRus: 4,
    background: "#fff",
    cursor: "pointer",
  },
  column2: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    marginBottom: "20px",
    borderRus: 4,
    background: "#fff",
    marginTop: "20px",
    cursor: "pointer",
  },
  staffUploadcolumn: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    marginBottom: "20px",
    borderRus: 4,
    background: "#fff",
    marginTop: "20px",
    cursor: "pointer",
  },
  uploadedFileContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    marginBottom: "20px",
    borderRus: 4,
    background: "#fff",
    marginTop: "20px",
    cursor: "pointer",
  },
  radioItem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 5,
    width: 70,
    borderRadius: 4,
    height: 30,
    // background: "rgba(242, 242, 242, 1)",
    // border: "1px solid #E5E5E5",
    cursor: "pointer",
  },
  radioItemSelected: {
    cursor: "pointer",
    borderRadius: 4,
    display: "flex",
    gap: 5,
    justifyContent: "center",
    alignItems: "center",
    width: 70,
    height: 30,
    border: "1px solid #E5E5E5",
    background: "#fff",
  },
  radioImage: {
    height: 18,
  },
  select: {
    width: "100px",
  },

  // folder item
  folderItem: {
    width: 200,
    margin: 10,
    padding: 10,
    position: "relative",
    borderRadius: 8,
    border: "1px solid #E4E4E7",
    background: "#FFF",

    // minHeight: 210,
  },

  disabledItem: {
    position: "relative",
    "&::after": {
      //content: '" "',
      position: "absolute",
      //cursor:'none',
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      //background: "rgba(0, 0, 0, 0.1)",
    },
  },

  verticalIconContainer: {
    position: "absolute",
    top: 5,
    right: 10,
  },
  folderDateText: {
    color: "rgba(151, 151, 151, 1)",
    // marginTop: "3px",
  },
  expiryDateText: {
    color: "red",
  },
  folderMenuIcon: {
    width: 20,
  },
  folderBig: {
    width: 100,
    // background: "red",
  },
  fileImageRow: { width: 20, margin: 5 },
  actionsImageRow: { width: 20, cursor: "pointer" },

  filePreview: {
    marginTop: 5,
    background: "#F4F4F5",
    padding: 10,
    borderRadius: 5,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  // upload documents modal
  uploadModal: {
    "& .mantine-Modal-body": {
      padding: 0,
    },
  },
  uploadHeader: {
    // background: "rgba(255, 186, 69, 0.85)",
    padding: 10,
  },
  dropzone: {
    "& .mantine-Dropzone-root": {
      background: "#F4F4F5",
    },
    width: "100%",
    padding: 10,
    marginBottom: 20,
  },
  modalHeaderImage: { width: 25 },
  dragImage: {
    alignSelf: "center",
    width: "35%",
  },
  browseText: {
    color: "rgba(107, 156, 255, 1)",
  },
  fileItem: {
    width: 250,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column",
    gap: 10,
    // background: "rgba(255, 186, 69, 0.25)",
    padding: "15px",
    margin: "5px",
    borderRadius: 8,
    border: "1px solid #E4E4E7",
  },
  dateDeleteContainer: {
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 5,
    gap: 10,
  },
  dateContainer: {
    borderRadius: 8,
    padding: 10,
    border: "1px solid #E0E0E0",
  },
  datePicker: {
    minWidth: 200,
    "& .mantine-InputWrapper-label": {
      marginLeft: 10,
    },
    "& .mantine-DatePickerInput-input": {
      borderRadius: 0,
      border: "1px solid rgba(242, 242, 242, 1)",
      // borderBottom: "2px solid rgba(255, 186, 69, 1)",
      // background: "rgba(242, 242, 242, 1)",
    },
  },
  notFoundTextContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "60vh",
    gap: "8rem",
    width: "100%",
  },
  notFoundText: {
    color: "gray",
    marginTop: 40,
  },
  tabsPanels: {
    width: "100%",
    marginTop: "1rem",
    display: "flex",
    alignItems: "start",
    columnGap: "1rem",
    flexWrap: "wrap",
  },
  fileSize: {
    color: "#979797",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "18px",
  },
  infoBox: {
    borderRadius: "8px",
    border: "1px solid  #E4E4E7",
    background: "#FFF",
    padding: "12px",
    margin: "15px 0",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "5px",
  },
  clientTitle: {
    color: "#171717",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0.01em",
    marginBottom: "3px",
  },
  searchInput: {
    width: "100%",
    marginBlock: "10px",
    marginBottom: "20px",
    borderRadius: "16px",
    "& :focus-within": {
      border: "1px solid #D0D5DD",
    },
    "& :focus": {
      border: "1px solid #D0D5DD",
    },
    "& :hover": {
      border: "1px solid #D0D5DD",
    },
    "& :active": {
      border: "1px solid #D0D5DD",
    },
    "& :focus-visible": {
      border: "1px solid #D0D5DD",
    },
  },
  fileExpiryContainer: {
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 5,
    gap: 10,
  },
  fileName: {
    borderRadius: 8,
    padding: 8,
    border: "1px solid #E0E0E0",
    display: "flex",
    flexDirection: "column",
    width: "200px",
    gap: 3,
  },



  permissionsGrid: {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '2rem',
  marginTop:'25px',
},

permissioncolumn: {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}

}));

export default useStyles;
